import { defineStore } from 'pinia';
import { ref, computed, watch } from 'vue';
import { useConfigStore } from '@/store/configStore';
import {
  canUseHospitalScope,
  normalizeAuthorizedHospitals,
  resolveAuthorizedHospitalCode,
} from '@/utils/institutionAccess';
import type { HospitalOption } from '@/utils/institutionAccess';

export const useInstitutionStore = defineStore('institution', () => {
  const configStore = useConfigStore();
  const options = ref<HospitalOption[]>([])
  const selectedId = ref(localStorage.getItem('selectedHospitalCode') || '')
  const loading = ref(false)
  /**
   * 是否是区域质控版本
   * 其他页面相关需要限制区域质控相关字段或功能，可通过该store判断
   */
  const isMultiRegion = computed(() => configStore.multiRegion);
  const hasHospitalAccess = computed(() =>
    canUseHospitalScope(isMultiRegion.value, options.value)
  );

  // 当前选中机构
  const currentSelected = computed(() =>
    options.value.find((item: any) => item.value === selectedId.value) || null
  )

  const setOptions = (hospitals: unknown) => {
    const authorizedOptions = normalizeAuthorizedHospitals(hospitals)
    options.value = authorizedOptions
    selectedId.value = resolveAuthorizedHospitalCode(authorizedOptions, selectedId.value)
  }

  const setSelectedId = (id: any) => {
    selectedId.value = id
  }

  watch(selectedId, (id) => {
    if (id) {
      localStorage.setItem('selectedHospitalCode', id)
    } else {
      localStorage.removeItem('selectedHospitalCode')
    }
  })

  return {
    isMultiRegion,
    hasHospitalAccess,
    options,
    selectedId,
    loading,
    currentSelected,
    setOptions,
    setSelectedId
  }
})
